<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import { TncManagementService } from "../../services/tnc/tnc.service";
import { usePermissions } from '@/composables/usePermissions';

export default {
  page: {
    title: "Program Management",
    meta: [{ name: "description", content: appConfig.description }],
  },

  data() {
    return {
      role: localStorage.getItem('role'),
      title: "Program Management",
      items: [
        {
          text: "Program Management",
          href: "/",
        },
      ],
      loadingRoles: true,
      programList: [],
      channelpartnerlist: [],
      fincoList: [],
      countryList: [],
      modalShow: true,
      ButtonSeen: true,
      tncFilesList: null,
      tnc: null,
      hasHouseDelivery: null,
    };
  },
  setup() {
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
  methods: {
    format_date(value) {
      if (value) {
        return moment(String(value)).format('DD-MM-YYYY H:m:s')
      }
    },
    getProgramList() {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.get(process.env.VUE_APP_API_BASEURL + 'program/list')
        .then(response => {
          if (response) {
            this.loadingRoles = false;
            this.programList = response.data;
          }
          else {
            this.messageBag = ['No record.'];
          }
        })
        .catch(error => {
          this.messageBag = [error.error];
        });
    },

    add_new_program(e) {
      if (this.program_code != '' || this.program_name != '') {
        e.preventDefault()
        const posting_ = {
          program_code: this.program_code,
          program_name: this.program_name,
          channel_partner: this.channel_partner,
          finco: this.finco,
          country: this.country,
          program_type: this.program_type,
          tnc_id: this.tnc,
          has_house_delivery: this.hasHouseDelivery
        };

        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.post(process.env.VUE_APP_API_BASEURL + 'program/create', posting_)
          .then(response => {
            if (response) {
              document.getElementById("add_new_program").reset();
              this.modalShow = false;
              alert(response.data.msj);

              this.$router.go(this.$router.currentRoute);
            } else {
              this.ButtonSeen = false;
            }
          });
      } else {
        e.preventDefault()
        alert('Please fill up the required fields.')
      }
    },

    //raw data----------------------------------------------------------

    get_channel_partner() {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.get(process.env.VUE_APP_API_BASEURL + 'channelpartner/raw_data')
        .then(response => {
          if (response) {
            this.channelpartnerlist = response.data;
          }
          else {
            this.messageBag = ['No record.'];
          }
        })
        .catch(error => {
          this.messageBag = [error.error];
        });
    },

    get_finco() {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.get(process.env.VUE_APP_API_BASEURL + 'finco/raw_data')
        .then(response => {
          if (response) {
            this.fincoList = response.data;
          }
          else {
            this.messageBag = ['No record.'];
          }
        })
        .catch(error => {
          this.messageBag = [error.error];
        });
    },

    get_country() {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
      axios.get(process.env.VUE_APP_API_BASEURL + 'finco/raw_data_country')
        .then(response => {
          if (response) {
            this.countryList = response.data;
          }
          else {
            this.messageBag = ['No record.'];
          }
        })
        .catch(error => {
          this.messageBag = [error.error];
        });
    },

    async get_tncs() {
      const response = await TncManagementService.getTnc();
      this.tncFilesList = response.data;
    }

    //raw data----------------------------------------------------------

  },

  components: {
    Layout,
    PageHeader,
    DataTable,
  },

  mounted() {
    this.getProgramList();
    this.get_channel_partner();
    this.get_finco();
    this.get_country();
    this.get_tncs();
  },

};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex justify-content-end mb-3">
      <button v-if="permissions.canCreate?.value" type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_new_program_modal"
        ><i class="ri-add-line align-middle me-1"></i> Add New Program</button> <br><br>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="live-preview">
          <div class="row align-items-center g-12">
            <div class="col-lg-12">
              <div v-if='loadingRoles'>
                <div class="spinner-border text-success" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <div v-else>
                <div class="table-responsive">
                  <DataTable class="table table-striped table-nowrap mb-0">
                    <thead class="table-secondary">
                      <tr>
                        <th>No.</th>
                        <th scope="col">Program Code</th>
                        <th scope="col">Program Id</th>
                        <th scope="col">Program Type</th>
                        <th scope="col">Name</th>
                        <th scope="col">Channel Partner</th>
                        <th scope="col">Finco</th>
                        <th scope="col">Country</th>
                        <th scope="col">Status</th>
                        <th scope="col">Created Date</th>
                        <th scope="col">Created By</th>
                        <!--th scope="col">Action</th-->
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(item, index) in programList" :key="index" class="content">
                        <td>{{ index + 1 }}</td>
                        <td><router-link :to="'/program/program-details/' + item.id" class="fw-medium link-secondary">{{
                          item.program_code }}
                          </router-link></td>
                        <td>{{ item.id }}</td>
                        <td>{{ item.program_type }}</td>
                        <td>{{ item.program_name }}</td>
                        <td>{{ item.channel_partner_name }}</td>
                        <td>{{ item.finco_name }}</td>
                        <td>{{ item.country_name }}</td>
                        <td v-if="item.status == 1"><span class="badge bg-success">Active</span>
                        </td>
                        <td v-else><span class="badge bg-danger">Disabled</span></td>
                        <td>{{ format_date(item.created_at) }}</td>
                        <td>{{ item.user_name }}</td>
                      </tr>
                    </tbody>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-------------------------------------------------------------
    ADD BRAND MODAL
    <------------------------------------------------------------->

    <div class="modal fade" id="add_new_program_modal" tabindex="-1" aria-labelledby="exampleModalgridLabel"
      v-if="modalShow">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalgridLabel">Add New Program</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <hr class="my-1 text-muted">
          <div class="modal-body">
            <form @submit="add_new_program" id="add_new_program">
              <div class="row g-3">
                <div class="col-xxl-12">
                  <div>
                    <label for="program_code" class="form-label">Program Code</label>
                    <input type="text" v-model='program_code' class="form-control" id="program_code"
                      placeholder="Enter Program Code" required />
                  </div>
                </div>
                <div class="col-xxl-12">
                  <div>
                    <label for="program_name" class="form-label">Program Name</label>
                    <input type="text" v-model='program_name' class="form-control" id="program_name"
                      placeholder="Enter Program Name" required />
                  </div>
                </div>
                <div class="col-xxl-12">
                  <label>Program Type</label>
                  <select v-model="program_type" class="form-select mb-0" arial-label="Default select example" required>
                    <option value="ONLINE">ONLINE</option>
                    <option value="OFFLINE">OFFLINE</option>
                  </select>
                </div>
                <div class="col-xxl-12">
                  <label>Channel Partner</label>
                  <select v-model="channel_partner" class="form-select mb-0" arial-label="Default select example"
                    placeholder="Please Select Channel Partner" required>
                    <option value="">--- Select Channel Partner ---</option>
                    <option v-for="(item, index) in channelpartnerlist" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xxl-12">
                  <label>Finco</label>
                  <select v-model="finco" class="form-select mb-0" arial-label="Default select example"
                    placeholder="Please Select Finco" required>
                    <option value="">--- Select Finco ---</option>
                    <option v-for="(item, index) in fincoList" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xxl-12">
                  <label>Country</label>
                  <select v-model="country" class="form-select mb-3" arial-label="Default select example"
                    placeholder="Please Select Country" required>
                    <option value="">--- Select Country ---</option>
                    <option v-for="(item, index) in countryList" :key="index" :value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xxl-12">
                  <label>TNC</label>
                  <select v-model="tnc" class="form-select mb-3" arial-label="Default select example"
                    placeholder="Please Select TNC" required>
                    <option value="">--- Select TNC ---</option>
                    <option v-for="(item, index) in tncFilesList" :key="index" :value="item.id">
                      {{ item.title }}
                    </option>
                  </select>
                </div>
                <div class="col-xxl-12">
                  <div class="form-check">
                    <input type="checkbox" id="has-house-delivery" v-model="hasHouseDelivery" class="form-check-input">
                    <label for="has-house-delivery" class="form-check-label">
                      Has house delivery address
                    </label>
                  </div>
                </div>
                <hr class="my-1 text-muted">

                <div class="col-lg-12">
                  <div class="hstack gap-2 justify-content-end">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-primary">Submit</button>
                  </div>
                </div>
                <!--end col-->
              </div>
              <!--end row-->
            </form>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>